import type { VisualisationConfig } from '@squaredup/dashboards';


const dataStreamTile = {
    baseTile: 'data-stream-base-tile',
    visualisation: {} as VisualisationConfig
} as const;

export default dataStreamTile;
